import Api from '@/services/Api';

export default {
  getSecondaryBatch(type, properties) {
    const requestData = {
      type,
      properties,
    };

    return Api().get('/batch/get-batch-by-configuration', {
      params: requestData,
    });
  },
};
